module.exports = __webpack_public_path__ + "static/media/Meetra_logo.49455897.png";